import { render, staticRenderFns } from "./UiCardContentLine.vue?vue&type=template&id=add54926&scoped=true&"
import script from "./UiCardContentLine.vue?vue&type=script&lang=js&"
export * from "./UiCardContentLine.vue?vue&type=script&lang=js&"
import style0 from "./UiCardContentLine.vue?vue&type=style&index=0&id=add54926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add54926",
  null
  
)

/* custom blocks */
import block0 from "./UiCardContentLine.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports